<section class="login-page">
  <div class='right-side'>
    <form [formGroup]="signUpForm" (ngSubmit)="submit()" class='mat-elevation-z3'>
      <h1>{{formName}}</h1>
      <p class='error' *ngIf='authenticatingError$ | async'>{{authenticatingError$ | async}}</p>
      <formly-form [model]="model" [fields]="fields" [options]="options" [form]="signUpForm"></formly-form>
      <button mat-raised-button color="primary" [disabled]="signUpForm.invalid">
        Login
      </button>
      <div class='other-links'>
        <a href="auth/reset-password">Forgot Password?</a>
        <a href="auth/sign-up">Don't have an account? create an account!</a>
      </div>
    </form>
  </div>
</section>
